<template>
  <div id="card card--placeholder">
    <div class="placeholder">
      <div class="placeholder__thumbnail" />
      <div class="placeholder__text" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardPlaceholder'
}
</script>

<style lang='scss' scoped>
.placeholder{
  &__thumbnail{
    max-width: 342px;
    width: 100%;
    height: 228px;
    // height: 100%;
    display: block;
  }
  &__text{
    margin-top: 8px;
    max-width: 300px;
    width: 100%;
    height: 22px;
    // height: 100%;
    display: block;
  }
  &__thumbnail,&__text{
    // https://codepen.io/pjosh/pen/ZOyEGr
    background: #ebebec;
    background-image: linear-gradient(to right, #ebebec 0%, #e0e0e2 20%, #ebebec 40%, #ebebec 100%);
    background-repeat: no-repeat;
    animation: placeholderLoading 1s infinite linear forwards;
  }
}

@keyframes placeholderLoading {
  0% {
    background-position: -300px 0
  }
  100% {
    background-position: 300px 0
  }
}
</style>
